import type { SandboxPath } from './types';

/**
 * Web Crypto の SubtleCrypto から sha256Hex を作る（sandboxd-client.md §4.5）。
 * 既定は `globalThis.crypto.subtle`。
 */
export function createSha256Hex(
  subtle: Pick<SubtleCrypto, 'digest'> = globalThis.crypto.subtle,
): (s: string) => Promise<string> {
  const encoder = new TextEncoder();
  return async (s) => {
    const buf = await subtle.digest('SHA-256', encoder.encode(s));
    return Array.from(new Uint8Array(buf), (b) => b.toString(16).padStart(2, '0')).join('');
  };
}

/** キャッシュキーの元になる文字列（§4.5）。fmt の stdins は []。 */
export function cacheKeySource(path: SandboxPath, code: string, stdins: string[]): string {
  return JSON.stringify({ v: 1, path, code, stdins });
}
